<template>
  <v-row justify="center" align="center">
    <v-col cols="12" lg="6">
      <v-stepper v-model="e6" vertical>
        <div class="padding-20">
          <h2>Sign Up</h2>
        </div>
        <v-stepper-step :complete="e6 > 1" step="1"
          >Chatham Place</v-stepper-step
        >

        <v-stepper-content step="1">
          <!-- <v-text-field
            v-model="accessCode"
            color="accent"
            label="community code"
            outlined
            prepend-inner-icon="fas fa-key"
          ></v-text-field> -->
          <v-select
            v-model="selectedRole"
            :items="rolesOptions"
            item-text="text"
            item-value="value"
            label="My role in the community is ..."
            required
            :rules="requiredRules"
            outlined
          ></v-select>
          <div class="padding-10">
            <router-link to="/signin">Already a user? Sign In</router-link>
          </div>
          <v-btn color="primary" @click="verifyAccess">Continue</v-btn>
          <v-btn text>Cancel</v-btn>
          <div class="padding-10">
            <v-alert :type="alertType" outlined v-if="this.alertMessage">{{
              this.alertMessage
            }}</v-alert>
          </div>
        </v-stepper-content>

        <v-stepper-step :complete="e6 > 2" step="2"
          >Select a Household</v-stepper-step
        >

        <v-stepper-content step="2">
          <v-row
            align="center"
            justify="center"
            align-content="center"
            justify-content="center"
          >
            <v-col cols="12" align="center">
              <v-form ref="household">
                <v-autocomplete
                  v-model="member.householdKey"
                  label="Address"
                  :items="households"
                  item-text="address"
                  item-value="id"
                  outlined
                  required
                  :rules="requiredRules"
                  clearable
                ></v-autocomplete>
                <v-text-field
                  v-model="householdName"
                  label="Household Nickname"
                  hint="Example: 'The Smiths'"
                  prepend-inner-icon="home"
                  outlined
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
          <v-btn color="primary" :disabled="snackbar" @click="validateHousehold"
            >Submit</v-btn
          >
          <v-btn text :disabled="snackbar" to="/signin">CANCEL</v-btn>
        </v-stepper-content>

        <v-stepper-step :complete="e6 > 3" step="3">Sign Up</v-stepper-step>

        <v-stepper-content step="3">
          <v-row
            align="center"
            justify="center"
            align-content="center"
            justify-content="center"
          >
            <v-col cols="12" lg="6" align="center">
              <v-form ref="form" lazy-validation>
                <v-text-field
                  v-model="member.firstName"
                  label="first name"
                  required
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="member.lastName"
                  label="last name"
                  required
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  required
                  v-model="member.licensePlate"
                  label="Tag"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-select
                  v-model="member.color"
                  outlined
                  :items="colors"
                  label="Car Color"
                >
                  <template v-slot:selection="data">
                    <v-icon :color="data.item">fas fa-circle</v-icon>
                    <span class="padding-10">{{ data.item }}</span>
                  </template>
                  <template v-slot:item="data">
                    <v-icon :color="data.item">fas fa-circle</v-icon>
                    <span class="padding-10">{{ data.item }}</span>
                  </template>
                </v-select>
                <v-text-field
                  required
                  v-model="member.carModel"
                  label="Car Model"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>

                <v-text-field
                  required
                  v-model="member.carYear"
                  label="Year"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="member.email"
                  label="email"
                  required
                  :rules="emailRules"
                  outlined
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="password"
                  :type="'password'"
                  prepend-inner-icon="fa fa-lock"
                  required
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  :type="'password'"
                  v-model="password2"
                  label="confirm password"
                  prepend-inner-icon="fas fa-lock"
                  outlined
                  @change="confirmPassword"
                  required
                  :rules="requiredRules"
                ></v-text-field>
                <v-alert
                  v-if="alertMessage != ''"
                  :type="alertType"
                  :color="alertType"
                  outlined
                  >{{ alertMessage }}</v-alert
                >
              </v-form>
            </v-col>
          </v-row>
          <v-row justify="center" align-content="center">
            <v-col cols="6">
              <v-checkbox
                v-model="agreed"
                label="I Have read the Privacy Policy"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row justify="center" align-content="center">
            <v-col>
              <a
                href="https://www.termsfeed.com/live/1182d1fa-e266-4129-98f0-43fd7413398c"
              >
                Privacy Policy</a
              >
            </v-col>
          </v-row>
          <v-btn text @click="e6 = 2">Back</v-btn>
          <v-btn
            color="primary"
            :disabled="!agreed ? '' : disabled"
            @click="validateForm"
            >Sign Up</v-btn
          >
          <v-btn text>Cancel</v-btn>
          <v-snackbar
            v-model="snackbar"
            color="primary darken-3"
            :timeout="0"
            light
            top
          >
            <v-avatar icon>
              <v-icon color="white" small>check</v-icon> </v-avatar
            >You're all set! Welcome to the NeighborGood. We've sent a
            verification email, please confirm your address.
            <v-btn text @click="snackbar = false" to="/signin">Sign In</v-btn>
          </v-snackbar>
        </v-stepper-content>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import {
  firebaseApp,
  communitiesRef,
  adminsRef,
  membersRef,
  householdsRef,
} from "../firebaseApp";
import roles from "./json/roles.json";
import adminObject from "./json/admin.json";
import memberObject from "./json/member.json";
import colorsOptions from "./json/colors.json";

export default {
  data: () => ({
    e6: 1,
    snackbar: false,
    agreed: false,
    colors: colorsOptions,
    isHouseholdDisabled: true,
    rolesOptions: roles,
    selectedRole: "",
    accessCode: "v5qhzs4cges",
    communityId: "",
    member: memberObject,
    admin: adminObject,
    communities: [],
    households: [],
    householdName: "",
    isValidated: false,
    email: "",
    requiredRules: [(v) => !!v || "Please fill out required fields"],
    emailRules: [
      (v) => !!v || "Email is required",
      (v) => /.+@+.+./.test(v) || "Email address is not valid",
    ],
    password: "",
    password2: "",
    alertType: "error",
    alertMessage: "",
  }),
  watch: {
    selectedRole: function (val) {
      if (val == "towingCompany") {
        //this.e6 = 3;
      }
    },
  },
  methods: {
    signUp() {
      firebaseApp
        .auth()
        .createUserWithEmailAndPassword(this.member.email, this.password)
        .then(() => {
          this.sendVerificationEmail();
        })
        .catch((error) => {
          this.alertType = "error";
          this.alertMessage = error.message;
        });
    },
    submitMember() {
      if (
        this.selectedRole == "boardMember" ||
        this.selectedRole == "towingCompany"
      ) {
        this.createAdminProfile();
      }
      this.member.dateAdded = Date.now();
      this.member.role = this.selectedRole;
      this.member.communityCode = this.accessCode;
      if (this.member.licensePlate == undefined) {
        this.member.licensePlate = "";
      }
      membersRef.push(this.member).key;
      this.updateHousehold();
      this.snackbar = true;
      this.$refs.form.reset();
      setTimeout(() => this.$router.push({ path: "/signin" }), 5000);
    },
    updateHousehold() {
      firebaseApp
        .database()
        .ref("/households/" + this.member.householdKey)
        .update({
          name: this.householdName,
          email: this.email,
        });
    },
    sendVerificationEmail() {
      var user = firebaseApp.auth().currentUser;
      user
        .sendEmailVerification()
        .then(() => {
          this.submitMember();
        })
        .catch((error) => {
          this.alertType = "error";
          this.alertMessage = error.message;
        });
    },
    createAdminProfile() {
      for (var prop in this.admin) {
        if (prop == this.selectedRole) {
          this.admin[prop] = true;
          this.admin.dateAdded = Date.now();
          this.admin.email = this.member.email;
          this.admin.name = this.member.firstName + " " + this.member.lastName;
          this.admin.communityCode = this.accessCode;
          this.superVerified = false;
        }
      }
      this.member.adminKey = adminsRef.push(this.admin).key;
    },
    loadHouseholds() {
      householdsRef.on("value", (snap) => {
        let households = [],
          communityId = this.communityId;
        snap.forEach((household) => {
          if (
            communityId == household.val().communityKey &&
            household.val().email == ""
          ) {
            let hh = {};
            hh = household.val();
            hh.id = household.key;
            hh.address = hh.aptNumber + " " + hh.streetName;
            households.push(hh);
          }
        });
        this.households = households;
      });
    },
    validateForm() {
      if (this.$refs.form.validate() && this.confirmPassword()) {
        this.signUp();
      }
    },
    validateHousehold() {
      if (this.$refs.household.validate()) this.e6 = 3;
    },
    verifyAccess() {
      let verified = false;
      this.alertMessage = "";
      this.communities.forEach((community) => {
        if (
          community.code == this.accessCode &&
          this.selectedRole != "towingCompany"
        ) {
          verified = true;
          this.communityId = community.id;
          this.loadHouseholds();
          this.e6 = 2;
        } else if (
          this.selectedRole == "towingCompany" &&
          this.accessCode != ""
        ) {
          verified = true;
          this.communityId = community.id;
          this.e6 = 3;
        }
      });
      if (!verified) {
        this.alertType = "error";
        this.alertMessage =
          "Please enter a valid access code to sign up. If you do not have one, check with one of the board members of your HOA";
      }
    },
    confirmPassword() {
      if (this.password != this.password2) {
        this.alertMessage = "Your passwords do not match";
        return false;
      } else {
        this.alertMessage = "";
        return true;
      }
    },
  },
  mounted() {
    this.$refs.form.reset();
    communitiesRef.on("value", (snap) => {
      snap.forEach((community) => {
        let comm = {};
        comm = community.val();
        comm.id = community.key;
        this.communities.push(comm);
      });
    });
  },
};
</script>
